import React from "react";

const ErrorText = ({ show, message }) => {
  return (
    <div>
      {show ? <div className="text-red-500 text-sm">{message}</div> : ""}
    </div>
  );
};

export default ErrorText;
